import React, { useMemo, useState } from "react";
import { Container, Tabs, Tab, Accordion } from "react-bootstrap";
import useIsDesktop from "../../../hooks/useIsDesktop";
import SpecificationTab from "./SpecificationTab";
import SectionTitle from "../../common/SectionTitle/SectionTitle";
import "./VehicleSpecificationsSection.css";
import { useTranslation } from "react-i18next";

export default function VehicleSpecificationsSection({ vehicle }) {
  const { t } = useTranslation();
  const isDesktop = useIsDesktop();

  const variants = vehicle?.specVariants || [];
  const categories = vehicle?.specifications || [];

  const defaultKey = useMemo(() => categories[0]?.id || "0", [categories]);
  const [activeKey, setActiveKey] = useState(defaultKey);

  if (!variants.length || !categories.length) return null;

  return (
    <section className="vehicle-specs section-spacing">
      <Container fluid>
        <div className="vehicle-specs__header text-center">
          <SectionTitle
            subtitle={t("vehicleSpecs.subtitle")}
            title={t("vehicleSpecs.title")}
          />

          <p className="brand-section-desc mb-0">{t("vehicleSpecs.desc1")}</p>
          <p className="brand-section-desc mb-0">{t("vehicleSpecs.desc2")}</p>
          <p className="brand-section-desc">{t("vehicleSpecs.desc3")}</p>
        </div>

        {isDesktop ? (
          <Tabs
            activeKey={activeKey}
            onSelect={(k) => setActiveKey(k)}
            className="vehicle-specs__tabs"
            mountOnEnter
            unmountOnExit
          >
            {categories.map((cat) => {
              const tabTitle = cat.titleKey ? t(cat.titleKey) : cat.title;

              return (
                <Tab eventKey={cat.id} title={tabTitle} key={cat.id}>
                  <div className="vehicle-specs__panel">
                    <SpecificationTab category={cat} variants={variants} />
                  </div>
                </Tab>
              );
            })}
          </Tabs>
        ) : (
          <Accordion defaultActiveKey={defaultKey} className="vehicle-specs__accordion">
            {categories.map((cat) => {
              const accTitle = cat.titleKey ? t(cat.titleKey) : cat.title;

              return (
                <Accordion.Item eventKey={cat.id} key={cat.id}>
                  <Accordion.Header>{accTitle}</Accordion.Header>
                  <Accordion.Body>
                    <SpecificationTab category={cat} variants={variants} />
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        )}
      </Container>
    </section>
  );
}